export default __webpack_public_path__ + "static/media/exportReport.baa9717e.svg";